import React from 'react';
import '../styles/Footer.css';

function Footer({ language }) {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo et description */}
        <div className="footer-section footer-brand">
          <div className="footer-logo">
            <img 
              src="https://raw.githubusercontent.com/Helmifalfie7/nexofortis/main/logodynamics/logo-nexo-modified2.png"
              alt="Nexofortis Logo" 
            />
            
          </div>
          <p className="footer-tagline">
            <span lang="en">Connecting systems. Automating processes. MuleSoft & Workato experts.</span>
            <span lang="fr">Connexion des systèmes. Automatisation des processus. Experts MuleSoft & Workato.</span>
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>
            <span lang="en">Quick Links</span>
            <span lang="fr">Liens Rapides</span>
          </h3>
          <ul>
            <li><a href="#home">
              <span lang="en">Home</span>
              <span lang="fr">Accueil</span>
            </a></li>
            <li><a href="#about">
              <span lang="en">About</span>
              <span lang="fr">À propos</span>
            </a></li>
            <li><a href="#values">
              <span lang="en">Values</span>
              <span lang="fr">Valeurs</span>
            </a></li>
            <li><a href="#sectors">
              <span lang="en">Sectors</span>
              <span lang="fr">Secteurs</span>
            </a></li>
            <li><a href="#contact">
              <span lang="en">Contact</span>
              <span lang="fr">Contact</span>
            </a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3>
            <span lang="en">Services</span>
            <span lang="fr">Services</span>
          </h3>
          <ul>
            <li><a href="#services">Mulesoft</a></li>
            <li><a href="#services">Workato</a></li>
           
          </ul>
        </div>

        {/* Follow Us */}
        <div className="footer-section">
          <h3>
            <span lang="en">Follow Us</span>
            <span lang="fr">Suivez-nous</span>
          </h3>
          <div className="social-links">
            <a href="https://www.linkedin.com/company/nexofortis-services-informatiques/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>
          © 2025 NEXOFORTIS - IT Services. 
          <span lang="en"> All rights reserved.</span>
          <span lang="fr"> Tous droits réservés.</span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
